"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var shuffle_1 = __importDefault(require("pandemonium/shuffle"));
function sort(items) {
    return shuffle_1["default"](items);
}
exports["default"] = sort;
//# sourceMappingURL=fisher-yates-random.js.map